

export enum ElementType {
    Interface,
    Enum,
    View,
    Class
}